/**
 * Behavior events for current visitor
 * @module
 */
var _ = require('optimizely-client-fn');
var actionTypes = require('../constants/action_types');
var BehaviorEvent = require('../behavior/event').Event;

module.exports = {
  initialize: function() {
    this.__state = {
      events: [],
      foreignEvents: {},
      foreignEventQueues: {},
    };

    this.on(actionTypes.SET_VISITOR_EVENTS, this.__loadData);
    this.on(actionTypes.SET_FOREIGN_VISITOR_EVENTS, this.__loadForeignEvents);
    this.on(actionTypes.SET_FOREIGN_VISITOR_EVENT_QUEUE, this.__loadForeignEventQueue);
  },

  /**
   *
   * @returns {module:behavior/event~Event[]}
   */
  getEvents: function(): import('core/behavior/event').Event[] {
    return this.__state.events;
  },

  /**
   *
   * @returns {Object.<module:behavior/event~Event[]>}
   */
  getForeignEvents: function(): Record<string, import('core/behavior/event').Event[]> {
    return this.__state.foreignEvents;
  },

  /**
   *
   * @returns {Object.<module:behavior/event~Event[]>}
   */
  getForeignEventQueues: function(): Record<string, import('core/behavior/event').Event[]> {
    return this.__state.foreignEventQueues;
  },

  /**
   * Behavior events
   * @param {module:behavior/event~Event[]} payload
   * @private
   */
  __loadData: function(payload:import('core/behavior/event').Event[]) {
    if (__INVARIANT__) {
      if (!_.isArray(payload)) {
        throw new Error('payload must be an array');
      }
      _.each(payload, function(event, i) {
        if (!(event instanceof BehaviorEvent)) {
          throw new Error('Error on payload[' + i + ']: Each instance of payload must be a behavior.Event instance');
        }
      });
    }
    this.__state.events = payload;
    this.emitChange();
  },

  /**
   *
   * @param {Object} payload
   * @param {string} payload.key
   * @param {module:behavior/event~Event[]} payload.value
   * @private
   */
  __loadForeignEvents: function(payload:any) {
    if (__INVARIANT__) {
      if (!_.isArray(payload.value)) {
        throw new Error('payload must be an array');
      }
      _.each(payload.value, function(event, i) {
        if (!(event instanceof BehaviorEvent)) {
          throw new Error('Error on payload[' + i + ']: Each instance of payload must be a behavior.Event instance');
        }
      });
    }
    this.__state.foreignEvents[payload.key] = payload.value;
  },

  /**
   *
   * @param {Object} payload
   * @param {string} payload.key
   * @param {module:behavior/event~Event[]} payload.value
   * @private
   */
  __loadForeignEventQueue: function(payload:any) {
    if (__INVARIANT__) {
      if (!_.isArray(payload.value)) {
        throw new Error('payload must be an array');
      }
      _.each(payload.value, function(event, i) {
        if (!(event instanceof BehaviorEvent)) {
          throw new Error('Error on payload[' + i + ']: Each instance of payload must be a behavior.Event instance');
        }
      });
    }
    this.__state.foreignEventQueues[payload.key] = payload.value;
  },
};
